import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5467c0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "vrt-body"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Trailer Not Found", -1))
const _hoisted_4 = { class: "vrt-actions" }
const _hoisted_5 = {
  key: 1,
  class: "vrt-body"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Trailer not available to Red Tag", -1))
const _hoisted_7 = { class: "vrt-subtitle" }
const _hoisted_8 = { class: "vrt-caption" }
const _hoisted_9 = { class: "vrt-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_fbx_button = _resolveComponent("fbx-button")!
  const _component_VirtualRedTagTrailerGraphic = _resolveComponent("VirtualRedTagTrailerGraphic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader),
    (_ctx.notFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_fbx_button, {
              "button-text": "Back to Home Screen",
              theme: "primary",
              onClick: _ctx.navigateToWelcome
            }, null, 8, ["onClick"])
          ])
        ]))
      : (_ctx.trailer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.subtitle), 1),
            _createVNode(_component_VirtualRedTagTrailerGraphic, {
              state: _ctx.GraphicState.blocked,
              company: _ctx.trailer.company
            }, null, 8, ["state", "company"]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.trailerTypeLabel) + " #" + _toDisplayString(_ctx.trailer.trailerNumber), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_fbx_button, {
                "button-text": "Back to Home Screen",
                theme: "primary",
                onClick: _ctx.navigateToWelcome
              }, null, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}